import { useState } from "react";
import IBullets from "../../types/IBullets";

export default function useBullets(props: IBullets) {
  const [list, setList] = useState<number[]>(new Array(props.qty).fill(""));

  return { list };
}
